import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  BU_id: null,
  BU_name: null,
  BU_status: null,
  BU_edit: false,
  BU_filter: true,
  BUIsPane: false,
  addBUIsPane: false,
};
export const BUReducerInner = createSlice({
  name: "BU",
  initialState: initialState,
  reducers: {
    BU_id(state, action) {
      state.BU_id = action.payload;
    },
    BU_name(state, action) {
      state.BU_name = action.payload;
    },
    BU_status(state, action) {
      state.BU_status = action.payload;
    },
    BU_edit(state, action) {
      state.BU_edit = action.payload;
    },
    BU_filter(state, action) {
      state.BU_filter = action.payload;
    },
    BU_IsPane(state, action) {
      state.BUIsPane = action.payload;
    },
    addBU_IsPane(state, action) {
      state.addBUIsPane = action.payload;
    },
  },
});
